
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

const ANIMATION_DURATION = 400;

type ChatwootWindow = {
  $chatwoot?: {
    toggleBubbleVisibility: (v: string) => void;
    toggle: (v?: string) => void;
    isOpen: boolean;
  }
};

const toggleChatwootBubble = (visible: boolean): void => {
  const chatwoot = (window as ChatwootWindow).$chatwoot;
  if (chatwoot) {
    chatwoot.toggleBubbleVisibility(visible ? 'show' : 'hide');
  }
};

@Component
export default class SidePanel extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Prop({ default: '475px' }) width!: string;

  private isRendered = false;

  private isAnimatedOpen = false;

  private wasChatwootOpen = false;

  @Watch('value', { immediate: true })
  private onValueChange(open: boolean): void {
    if (open) {
      this.openPanel();
    } else {
      this.closePanel();
    }
  }

  get panelStyle(): Record<string, string> {
    return { width: this.width };
  }

  private openPanel(): void {
    const chatwoot = (window as ChatwootWindow).$chatwoot;
    this.wasChatwootOpen = !!chatwoot?.isOpen;

    if (chatwoot?.isOpen) {
      chatwoot.toggle('close');
    }

    toggleChatwootBubble(false);

    this.isRendered = true;
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.isAnimatedOpen = true;
      });
    });
  }

  private closePanel(): void {
    if (!this.isRendered) return;
    this.isAnimatedOpen = false;

    setTimeout(() => {
      this.isRendered = false;

      toggleChatwootBubble(true);

      if (this.wasChatwootOpen) {
        const chatwoot = (window as ChatwootWindow).$chatwoot;
        if (chatwoot) {
          chatwoot.toggle('open');
        }
      }

      this.$emit('input', false);
      this.$emit('close');
    }, ANIMATION_DURATION);
  }

  private close(): void {
    this.closePanel();
  }

  beforeDestroy(): void {
    if (this.isRendered) {
      this.isRendered = false;
      toggleChatwootBubble(true);
    }
  }
}
